import { Routes, Route } from "react-router-dom";
import "./App.css";
import "./style/Color.css";
import "./style/Table.css";
import "./style/Button.css";
import "./style/Inputs.css";
import "./style/Temporary.css";
import "./style/LeaveBalance.css";
import "./style/Dashboard.css";
import "./style/CompanyStructure.css";
import "./style/JopApplication.css";
import "./style/AppraisalModal.css";
import "./style/UploadIncrementDataBulk.css";

import Auth from "./routes/Auth";
import React, { useState, useEffect } from "react";
import Internet from "./assets/gif/internet-down.gif";
import Server from "./assets/gif/server-down.gif";
import "bootstrap/dist/css/bootstrap.min.css";
import 'react-quill/dist/quill.snow.css';
import PageNotFound from "./pages/PageNotFound";
import { routingData } from "./routes/routing";
import RedirectRouter from "./routes/RedirectRouter";
import Fireworks from './Fire'
import { setupSecureStorage, clearEncryptionKey, getCurrentEncryptionKey, setEncryptionKey, runIntegrityCheck } from './utils/secureStorage';
import usePermission from "./config/permissions";
import TimeZoneTamperDetection from "./utility/TimeZoneTamperDetection";
import Loader from "./components/Loader";
import ScrollToTop from "./components/ScrollToTop";

setupSecureStorage();

// ALSO restore the encryption key IMMEDIATELY if there's an existing session
const existingToken = sessionStorage.getItem('access_token');
if (existingToken) {
  console.log('🔑 Restoring encryption key from existing session on app load');
  setEncryptionKey(existingToken);
}

function App() {
  useEffect(() => {
    // This is just for cleanup now
    return () => {
      clearEncryptionKey();
    };
  }, []);

  const recursiveRouter = (props) => {
    const { nestedRoutes, routes, isProtected, role } = props;
    const authenticatedRouted = () => {
      return (
        <>
          {routes &&
            routes.map((e, index) => (
              <Route key={index} path={e.path} element={e.component} />
            ))}
          {nestedRoutes &&
            nestedRoutes.map((e, index) => (
              <Route path={e.path} element={e.component} key={index}>
                {recursiveRouter(e)}
              </Route>
            ))}
        </>
      );
    };

    return isProtected ? (
      <Route element={<Auth allowedRoles={role} />}>
        {authenticatedRouted()}
      </Route>
    ) : role === "" ? (
      <Route element={<RedirectRouter />}>{authenticatedRouted()}</Route>
    ) : (
      <>{authenticatedRouted()}</>
    );
  };


  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const serverOnline = true;

  useEffect(() => {
    const handleOnlineStatus = () => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener("online", handleOnlineStatus);
    window.addEventListener("offline", handleOnlineStatus);

    return () => {
      window.removeEventListener("online", handleOnlineStatus);
      window.removeEventListener("offline", handleOnlineStatus);
    };
  }, []);

  useEffect(() => {
    // Disable right-click
    document.body.oncontextmenu = (e) => e.preventDefault();

    // Disable F12, Ctrl + Shift + I, Ctrl + Shift + J, Ctrl + U
    document.onkeydown = function (e) {
      const blockedKeys = ["F12", "ControlShiftC", "ControlShiftI", "ControlShiftJ", "ControlU"];
      if (
        blockedKeys.includes(e.code) ||
        (e.ctrlKey && e.shiftKey && (e.code === "KeyI" || e.code === "KeyJ")) ||
        (e.ctrlKey && e.code === "KeyU")
      ) {
        e.preventDefault();
        return false;
      }
    };

    return () => {
      document.onkeydown = null;
    };
  }, []);

  const {
    showTimeBlocker,
    blockerData,
    retryTimeCheck,
    timeDifferenceLoader,
    sslError
  } = usePermission();

  return (
    <>
      {/* <TimeTamperWrapper> */}
      {/* <Fireworks /> */}
      {timeDifferenceLoader && <Loader />}
      {
        showTimeBlocker ?
          <TimeZoneTamperDetection
            serverTimeData={blockerData}
            onRetry={retryTimeCheck}
          // isSslError={sslError}
          />
          :
          isOnline ? (
            serverOnline ? (
              <Routes>
                {routingData.map((e, index) => {
                  return (
                    <React.Fragment key={index.toString()}>
                      {recursiveRouter(e)}
                    </React.Fragment>
                  );
                })}
                {/* Extra Routes */}
                <Route path="*" element={<PageNotFound />} />
              </Routes>
            ) : (
              <center>
                {" "}
                <br /><br /><br /><br /><br /><br /><br /><br />
                <p>
                  You Are Online but, the Server is Offline. <br />
                  <b>Please be Patient. We are working hard to fix it.</b> <br />
                  <br />
                  <img
                    style={{
                      borderRadius: "20px",
                      boxShadow: "0px 1px 38px 0px rgba(0, 0, 0, 0.10)",
                    }}
                    src={Server}
                    alt=""
                  />
                </p>
              </center>
            )
          ) : (
            <center>
              {" "}
              <br /><br /><br /><br /><br /><br /><br /><br />
              <p>
                You are offline. Because Internet connection Is Not Working. <br />
                <b>Our Software is working Fine :)</b> <br />
                <br />
                <img
                  style={{
                    borderRadius: "20px",
                    boxShadow: "0px 1px 38px 0px rgba(0, 0, 0, 0.10)",
                  }}
                  src={Internet}
                  alt=""
                />
              </p>
            </center>
          )}
      {/* </TimeTamperWrapper> */}
      <ScrollToTop />
    </>
  );
}

//demo demo
export default App;
